import React from "react";

const BranchLogo = () => (
  <img style={{height: '1.2em'}} src="https://cdn.shopify.com/s/files/1/0124/5662/4187/files/branch-logo-new_600x.png?v=1572905797" />
);

export default BranchLogo;
